// Public URLs moved; guideType, slugs and browser progress keys stay unchanged.
function canonicalGuidePath(path) {
  if (typeof path !== 'string') return path;
  const match = path.match(/^(https:\/\/gab\.ai)?\/docs\/learn(?=\/|[?#]|$)(\/[^?#]*)?([?#].*)?$/);
  if (/^(https:\/\/gab\.ai)?\/docs#learn(?:-lessons)?$/.test(path)) {
    return path.replace(/\/docs#learn(?:-lessons)?$/, '/learn');
  }
  if (!match) return path;
  const [, origin = '', lesson = '', suffix = ''] = match;
  if (lesson && lesson !== '/index' && lesson !== '/') return `${origin}/learn${lesson}${suffix}`;
  return `${origin}/learn${suffix}`;
}

function canonicalGuideLinks(value) {
  if (typeof value === 'string') return canonicalGuidePath(value);
  if (Array.isArray(value)) {
    const mapped = value.map(canonicalGuideLinks);
    return mapped.some((item, index) => item !== value[index]) ? mapped : value;
  }
  if (value && typeof value === 'object' && Object.getPrototypeOf(value) === Object.prototype) {
    const entries = Object.entries(value).map(([key, item]) => [key, canonicalGuideLinks(item)]);
    return entries.some(([key, item]) => item !== value[key]) ? Object.fromEntries(entries) : value;
  }
  return value;
}


const RETIRED = new Set(['docs:fast-mode', 'learn:work-game-builder']);
function isRetiredGuide(type,slug) { return RETIRED.has(`${type}:${slug}`); }

module.exports = { canonicalGuidePath, canonicalGuideLinks, isRetiredGuide };
